import { TableCell, TableRow } from "@mui/material";
import moment from "moment";
import { formatUtcDateTimeInLabTimeZone } from "Utils/Common/LabTimeZone";

function Row({ row, labTimeZone }: any) {
  return (
    <>
      <TableRow className="h-30px">
        <TableCell
          id={`NGSRunCreationRunName_${row.id}`}
          sx={{ width: "max-content", whiteSpace: "nowrap" }}
        >
          {row?.runName}
        </TableCell>
        <TableCell
          id={`NGSRunCreationorderCode_${row.id}`}
          sx={{ width: "max-content", whiteSpace: "nowrap" }}
        >
          {formatUtcDateTimeInLabTimeZone(
            row?.runDate,
            labTimeZone,
            "MM/dd/yyyy"
          ) ?? moment(row?.runDate)?.format("MM/DD/YYYY")}
        </TableCell>
        <TableCell
          id={`NGSRunCreationcreatedName_${row.id}`}
          sx={{ width: "max-content", whiteSpace: "nowrap" }}
        >
          {row?.createdName}
        </TableCell>
      </TableRow>
    </>
  );
}

export default Row;
